export class APIFeatures
{
    static FAILURE = "FAILURE";
    static SUCCESS = "SUCCESS";
    static CONFIGURATION = "CONFIGURATION";
    static LOAD_APP_CONTEXT = "LOAD_APP_CONTEXT";

    static LOAD_HELP = "LOAD_HELP";
    
    static SUBSCRIBER_VALIDATION = "SUBSCRIBER_VALIDATION";
    static SECURITY_TOKEN = "SECURITY_TOKEN";
    static PASSWORD_VALIDATION = "PASSWORD_VALIDATION";
    static PASSWORD_VALIDATION_CC = "PASSWORD_VALIDATION_CC";
    static LOGIN = "LOGIN";
    static LOGIN_VALIDATION = "LOGIN_VALIDATION";
    static RESET_PASSWORD = "RESET_PASSWORD";
    static CREATE_ACCOUNT = "CREATE_ACCOUNT";
    static GENERATE_OTP = "GENERATE_OTP";
    static OTP_CHECK = "OTP_CHECK";
    static CONFIRM_OTP = "CONFIRM_OTP";
    static SEND_OTP = "SEND_OTP";

    static BANNER = "BANNER";
    static FEATURED_CATEGORIES = "FEATURED_CATEGORIES";
    static LOAD_MORE_TONES = "LOAD_MORE_TONES";
    static CATEGORIES = "CATEGORIES";
    static GET_BANNER_DETAILS = "GET_BANNER_DETAILS";
    static BANNER_SEARCH = "BANNER_SEARCH";
    static SEARCH_TONE = "SEARCH_TONE";
    static SPECIFIC_SEARCH_TONE = "SPECIFIC_SEARCH_TONE";
    static GET_PLAY_LIST = "GET_PLAY_LIST";
    static FAQ = "FAQ";
    static SIGNUP_CATEGORIES = "SIGNUP_CATEGORIES";
    static LIST_LIKE_TONE = "LIST_LIKE_TONE";
    static LIKE_UNLIKE_TONE = "LIKE_UNLIKE_TONE";
    static ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
    static DELETE_FROM_WISHLIST = "DELETE_FROM_WISHLIST";
    static GET_WISHLIST = "GET_WISHLIST";
    static GIFT_TONE = "GIFT_TONE";
    static BUY_TONE = "BUY_TONE";
    static REFER_TONE = "REFER_TONE";
    static GET_TONE_PRICE = "GET_TONE_PRICE";
    static EDIT_PROFILE = "EDIT_PROFILE";
    static GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
    static PACK_STATUS = "PACK_STATUS";
    static TRANSACTION_HISTORY = "TRANSACTION_HISTORY";
    static LOGOUT = "LOGOUT";
    static REGENERATE_TOKEN = "REGENERATE_TOKEN";
    static UN_AUTHORISED = "UN_AUTHORISED";
    static UPLOAD_KAROAKE = "UPLOAD_KAROAKE";
    static GET_KAROAKE_LIST = "GET_KAROAKE_LIST";
    static SALATI_ACTIVATION = "SALATI_ACTIVATION";
    static SALATI_DEACTIVATION = "SALATI_DEACTIVATION";
    static SALATI_STATUS = "SALATI_STATUS";
    static SALATI_TONEDETAILS = "SALATI_TONEDETAILS";
    static MUSIC_BOX_CONTENTS = "MUSIC_BOX_CONTENTS";
    static BUY_MUSIC_CHANNEL = "BUY_MUSIC_CHANNEL";
    static PREVIEW_TONE = "PREVIEW_TONE";
    static LIST_TONES = "LIST_TONES";
    static MYLIBRARY_TUNES = "MYLIBRARY_TUNES";
    static PROFILE_TUNES = "PROFILE_TUNES";
    static MYLIBRARY_PLAYLIST = "MYLIBRARY_PLAYLIST";
    static DELETE_FROM_SHUFFLE = "DELETE_FROM_SHUFFLE";
    static DELETE_DEDICATION = "DELETE_DEDICATION";
    static DELETE_TONE = "DELETE_TONE";
    static ADVANCE_SETTINGS = "ADVANCE_SETTINGS";
    static TIME_BASED_SETTING_FOR_ALL_CALLERS = "TIME_BASED_SETTING_FOR_ALL_CALLERS";
    static TIME_BASED_SETTING_FOR_CALLERS_GROUP = "TIME_BASED_SETTING_FOR_CALLERS_GROUP";
    static TIME_BASED_SETTING_FOR_SPECIFIC_CALLER = "TIME_BASED_SETTING_FOR_SPECIFIC_CALLER";
    static CREATE_GROUP = "CREATE_GROUP";
    static EDIT_GROUP = "EDIT_GROUP";
    static DELETE_GROUP = "DELETE_GROUP";
    static LIST_GROUP = "LIST_GROUP";
    static ADD_TO_BLACKLIST = "ADD_TO_BLACKLIST";
    static REMOVE_FROM_BLACKLIST = "REMOVE_FROM_BLACKLIST";
    static VIEW_BLACKLIST = "VIEW_BLACKLIST";
    static CREATE_BLACKLIST= "CREATE_BLACKLIST";
    static SUBSCRIPTION_PLAN_DETAILS = "SUBSCRIPTION_PLAN_DETAILS";
    static ADD_NAMETUNE = "ADD_NAMETUNE";
    static SETTINGS = "SETTINGS";
    static SHUFFLE ="SHUFFLE";
    static DEFAULT_TONE = "DEFAULT_TONE";
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/util/apifeatures.tsx